
<template  aspectRatio="2">
<div>
  <canvas :id="id">
    Your browser does not support the canvas element.
  </canvas>
</div>

</template>

<script>
export default {
  props: {
    onClick: {
      default: () => () =>{ },
    },
    id: {
      require: true,
    },
    legendDisplay: {
      default: true,
    },
    data:{
      default: () => []
    },
    colors:{
      default: () => [
        'rgba(255, 99, 132, 0.2)',
        'rgba(54, 162, 235, 0.2)',
        'rgba(255, 206, 86, 0.2)',
        'rgba(75, 192, 192, 0.2)',
        'rgba(153, 102, 255, 0.2)',
        'rgba(255, 159, 64, 0.2)'
      ]
    },
    borderColor:{},
    fontColor: {
      default: 'black'
    },
    labels:{
      default: () => ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange']
    }
  },
  data() {
    return {
      myDoughnutChart:'',
    };
  },
  watch: {
    data(val) {
      this.load()
    },
    labels(val){
      this.load();
    },
    '$vuetify.breakpoint.name'(val) {
      this.myDoughnutChart.aspectRatio = ['sm','xs', 'md'].includes(val)
      ? 1
      : 2;
    }
  },
  mounted(){
    this.load();
  },
  methods: {
    load(){
      const {onClick} = this;
      var Chart = require('chart.js');
      var ctx = document.getElementById(this.id).getContext('2d');
      if (this.myDoughnutChart.destroy) this.myDoughnutChart.destroy();
      this.myDoughnutChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: this.labels,
          datasets: [
            {
              data: this.data,
              labels: this.labels,
              backgroundColor: this.colors,
              borderColor: this.borderColor || this.colors,
            }
          ]
        },
        options:{
          onClick,
          hover: {
            onHover: function(e) {
              var point = this.getElementAtEvent(e);
              if (point.length) e.target.style.cursor = 'pointer';
              else e.target.style.cursor = 'default';
            }
          },
          animation:{animateRotate: false},
          legend: {
              display: this.legendDisplay,
              position: 'bottom',
              labels: {
                  fontColor: this.fontColor
              }
          }
        }
      });
      this.myDoughnutChart.aspectRatio = ['sm','xs', 'md'].includes(this.$vuetify.breakpoint.name)
        ? 1
        : 2;
    }
  }, // methods
};
</script>
